import { render, staticRenderFns } from "./driver-detail.vue?vue&type=template&id=bedf3d8c&scoped=true"
import script from "./driver-detail.vue?vue&type=script&lang=js"
export * from "./driver-detail.vue?vue&type=script&lang=js"
import style0 from "./driver-detail.vue?vue&type=style&index=0&id=bedf3d8c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedf3d8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bedf3d8c')) {
      api.createRecord('bedf3d8c', component.options)
    } else {
      api.reload('bedf3d8c', component.options)
    }
    module.hot.accept("./driver-detail.vue?vue&type=template&id=bedf3d8c&scoped=true", function () {
      api.rerender('bedf3d8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/driver/components/driver-detail.vue"
export default component.exports